// Paralax scroll effect
document.addEventListener('DOMContentLoaded', () => {
    const images = document.querySelectorAll('.parallax-image img');

    // Justera parallaxhastighet beroende på skärmstorlek
    const isMobile = window.innerWidth < 768;
    const speed = isMobile ? 0.05 : 0.2;

    const state = [];

    // Initiera varje bilds offset till 0
    images.forEach((img) => {
        state.push({
            img,
            current: 0,
            target: 0
        });
    });

    function update() {
        const windowHeight = window.innerHeight;
        state.forEach((item) => {
            const rect = item.img.getBoundingClientRect();
            if (rect.bottom > 0 && rect.top < windowHeight) {
                item.target = rect.top * speed * -1;
            } else {
                item.target = 0;
            }
            item.current += (item.target - item.current) * 0.1;
            item.img.style.transform = `translateY(${item.current}px)`;
        });
        requestAnimationFrame(update);
    }

    requestAnimationFrame(update);
});

// Range slider calculator
document.addEventListener("DOMContentLoaded", () => {
    const slider = document.getElementById("myRange");
    const output = document.getElementById("sliderValue");
    const editBtn = document.getElementById("editBtn");
    const editIcon = document.getElementById("editIcon");

    function updateSliderBackground(slider) {
        const value = (slider.value - slider.min) / (slider.max - slider.min) * 100;
        slider.style.background = `linear-gradient(to right, #159681 0%, #159681 ${value}%, #e9e6e0 ${value}%, #e9e6e0 100%)`;
    }

    let isEditing = false;

    editBtn.addEventListener("click", () => {
        if (!isEditing) {
            output.readOnly = false;
            output.focus();
            output.select();
            updateEditIcon(true);
            isEditing = true;
        } else {
            const cleaned = output.value.replace(/\D/g, '');
            const numericValue = parseInt(cleaned, 10);

            if (!isNaN(numericValue)) {
                output.value = new Intl.NumberFormat("sv-SE").format(numericValue) + " kr";
                calculateMonthlyCost(numericValue);
            }

            output.readOnly = true;
            updateEditIcon(false);
            isEditing = false;
        }
    });

    output.addEventListener("keydown", (e) => {
        if (e.key === "Enter" && isEditing) {
            editBtn.click();
        }
    });

    function updateEditIcon(editing) {
        editIcon.innerHTML = editing
            ? `<img decoding="async" src="/wp-content/themes/contrl.se/static/images/check.svg">`
            : `<img decoding="async" src="/wp-content/themes/contrl.se/static/images/edit.svg">`;
    }

    // Slider uppdatering
    slider.addEventListener("input", () => {
        updateSliderBackground(slider);
        updateSliderDisplay();
    });

    updateSliderBackground(slider);

    const minVal = 25000;
    const maxVal = 2500000;

    function getLogValue(position) {
        const minLog = Math.log(minVal);
        const maxLog = Math.log(maxVal);
        const scale = position / 100;
        const logValue = minLog + (maxLog - minLog) * scale;
        return Math.round(Math.exp(logValue));
    }

    function updateSliderDisplay() {
        const logValue = getLogValue(slider.value);
        output.value = new Intl.NumberFormat("sv-SE").format(logValue) + " kr";
        calculateMonthlyCost(logValue);
    }

    function calculateMonthlyCost(annualRevenue) {
        const getMonthlyBaseCost = (cls) => {
            const el = document.querySelector(`.${cls}`);
            const match = el.textContent.replace(/\s/g, '').match(/([\d\s]+)/);
            return match ? parseInt(match[1].replace(/\s/g, '')) : 0;
        };

        const getTransactionPercent = (cls) => {
            const el = document.querySelector(`.${cls}`);
            const match = el.textContent.match(/(\d+([.,]\d+)?)/g);
            if (!match) return 0;
            const percents = match.map(p => parseFloat(p.replace(',', '.')));
            return Math.min(...percents);
        };

        const formatCurrency = (value) => {
            return new Intl.NumberFormat("sv-SE").format(Math.round(value)) + " kr *";
        };

        const monthZBase = getMonthlyBaseCost("monthly-cost-z");
        const transZ = getTransactionPercent("trans-cost-z");
        const monthZ = monthZBase + ((annualRevenue * (transZ / 100)) / 12);
        document.querySelector(".month-cost-z").textContent = formatCurrency(monthZ);

        const monthYBase = getMonthlyBaseCost("monthly-cost-y");
        const transY = getTransactionPercent("trans-cost-y");
        const monthY = monthYBase + ((annualRevenue * (transY / 100)) / 12);
        document.querySelector(".month-cost-y").textContent = formatCurrency(monthY);

        const monthCBase = getMonthlyBaseCost("monthly-cost-c");
        const transC = getTransactionPercent("trans-cost-c");
        const monthC = monthCBase + ((annualRevenue * (transC / 100)) / 12);
        document.querySelector(".month-cost-c").textContent = formatCurrency(monthC);
    }

    updateSliderDisplay();
});